module.exports = __webpack_public_path__ + "static/img/img06.5a60515.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aifv/img06.png
// module id = MW0h
// module chunks = 1